import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { provideHttpClient } from '@angular/common/http';
import { TRADGINE_DATA_API_BASE_URL } from '@tradgine/data-access/tradgine-data';
import { LOCALE_ID } from '@angular/core';
import { APP_CONFIG } from './env/env.token';
import { AppConfig } from './env/app-config.model';
import { env } from './env/env';

bootstrapApplication(AppComponent, {
    providers: [
        provideHttpClient(),
        {
            provide: APP_CONFIG,
            useValue: env,
        },
        {
            provide: TRADGINE_DATA_API_BASE_URL,
            useFactory: (cfg: AppConfig) => cfg.tradgineDataUrl,
            deps: [APP_CONFIG],
        },
        {
            provide: LOCALE_ID,
            useFactory: () => {
                const lang = document?.documentElement?.lang || navigator.language || 'en';
                return lang.startsWith('es') ? 'es-ES' : 'en-GB';
            },
        },
    ],
}).catch((err) => console.error(err));


